import { useQuery } from "@tanstack/react-query";
import { getUserMe } from "../api";
import { getToken } from "../../../utils/API";

export const useGetUserMe = () => {
  const token = getToken();

  const { data, isLoading } = useQuery({
    queryKey: ["user-me"],
    queryFn: getUserMe,
    select: ({ data }) => data,
    enabled: !!token, // Cek apakah rute saat ini bukan '/login'
  });

  return { userMe: data, isLoading };
};
